import PropTypes from "prop-types";
import ReportHeader from "./ReportHeader";
import { TR } from "./BusinessDashboard/Table/Table";

const AgentTextsHeaders = ({ sortBy, sortKey, sortDesc }) => (
  <TR className="tw-bg-white tw-sticky tw-top-0">
    <ReportHeader name="agent" sortDesc={sortDesc} sortKey={sortKey} label="Name" handleSort={sortBy} />
    <ReportHeader
      name="text_report_agent_total_lead_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Leads"
      tooltipDesc="Contacts assigned to the agent during this date range, including contacts in ponds the agent is the display agent for. Excludes archived and trashed contacts and contacts without an email or phone number."
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_lead_text_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Leads Texted"
      tooltipDesc="Unique leads texted during this date range that are assigned to the agent or in a pond the agent owns"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_non_lead_text_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Others Texted"
      tooltipDesc="Other unique contacts texted during this date range that are neither assigned to the agent nor in a pond the agent owns"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_total_texts"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Texts Sent"
      tooltipDesc="Total number of text messages sent"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_total_texts_recd"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Texts Received"
      tooltipDesc="Total number of text messages received"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_total_text_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Texts"
      tooltipDesc="Combined count of all sent and received text messages"
      handleSort={sortBy}
    />
  </TR>
);

AgentTextsHeaders.propTypes = {
  sortBy: PropTypes.func.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
};

export default AgentTextsHeaders;
